import logger from 'src/utils/logger/logger';
import * as loader from '../requests/loader';
import storage from '../components/DeviceStorage/DeviceStorage';
import Launcher from '../requests/apa/Launcher';import Device from '../devices/device';
import Utils from '../utils/Utils';
import { TimeshiftUtil } from '../AAF/Timeshift/TimeshiftUtil';
import store from '../store';
import { fetchIsLoggedIn } from '../reducers/user';
import { FROM_APP } from '../AAF/Resilence/main';

// Promesa de isloggedin disparada aquí mismo (cuando hay HKS), para que
// App/index.jsx la reutilice en vez de volver a disparar la petición en su componentWillMount.
export let isLoggedInStartupPromise = null;

async function loadStartHeaderInfo() {
  const startedAt = Date.now();

  try {
    const result = await loader.startHeaderInfo();
    const isSuccessful = Boolean(result && result.response && result.response.region);

    trackRequestComplete('init.country.complete', {
      endpoint: 'services/user/startheaderinfo',
      startedAt,
      result: isSuccessful ? 'success' : 'error',
      error: isSuccessful ? null : result,
      source: result,
    });

    return result;
  } catch (error) {
    trackRequestComplete('init.country.complete', {
      endpoint: 'services/user/startheaderinfo',
      startedAt,
      result: 'error',
      error,
      source: error,
    });

    throw error;
  }
}

/**
 *
 * @param {*} resp
 * @returns
 */
function stringifyLauncherResponse(resp) {
  let _resp = resp;

  if(Utils.isObject(resp)) {
    _resp = JSON.stringify(resp);
  }
  else if(Utils.isNullOrUndefined(resp)) {
    _resp = 'Empty response';
  }
  else if(Utils.isJson(resp)) {
    _resp = JSON.stringify(resp);
  }
  else {
    try {
      _resp = resp + '';
    }
    catch(er) {}
  }

  return _resp;
}

export default async function loadInitApis() {

  const hks = storage.getItem('HKS');
  const refresh = storage.getItem('refresh');
  if (hks && refresh) {
    storage.setItem('HKS', '');
    storage.unsetItem('refresh');
  }

  // Set Launcher data with akamai_mfwk configuration
  const {akamai_mfwk = '' }= Device.getDevice().getConfig();
  Launcher.setData({ akamai_mfwk : akamai_mfwk.replace(/^(https?|ftp):\/\//, '') });

  await loader.startHeaderInfo();

  const concurrentRequests = [
    loader.apaMetadataMiddleware(),
    loader.apaAsset()
  ];

  isLoggedInStartupPromise = store.dispatch(fetchIsLoggedIn(FROM_APP));
    
  // El render solo espera las APA necesarias para construir la aplicación.
  Promise.all(concurrentRequests);

  const devicePlatform = TimeshiftUtil.getDevicePlatform();
  if (devicePlatform) {
    const hasTimeshiftSupported = await TimeshiftUtil.hasTimeshiftSupported(devicePlatform);
    if (!hasTimeshiftSupported) {
      logger.debug("[applicationLoader] Timeshift is not supported", devicePlatform, hasTimeshiftSupported);
      TimeshiftUtil.disableTimeshiftKeys();
    }
  }

  return new Promise(resolve => {
    resolve();
  });
}



// WEBPACK FOOTER //
// ./src/config/applicationLoader.js